import { Icon } from "@iconify/react";
import Swal from "sweetalert2/dist/sweetalert2.js";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import CustomButton from "../common/CustomButton";
import CustomInput from "../common/CustomInput";
import Aos from "aos";
import "./style.css";
import axios from 'axios';
import { CircularProgress } from "@mui/material";


const GetTouchFrom = () => {
  const [mail, setMail] = useState({
    name: "",
    email: "",
    phone: "",
    country: "",
    msg: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setMail({ ...mail, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true)
    axios.post('https://emc-new-backend.vercel.app/send-mail', mail)
      .then(response => {
        // Handle the response data

        if (response.data.success) {
          setMail({
            name: "",
            email: "",
            phone: "",
            country: "",
            msg: "",
          })
          setIsLoading(false)

        }
      })
      .catch(error => {
        // Handle the error
        console.log(error)
        setIsLoading(false)
      });
  };

  React.useEffect(() => {
    Aos.init({
      offset: 50,
      duration: 800,
      easing: "ease-in-sine",
      delay: 100,
    });
  });
  return (
    <div className="rounded-xl mb-[75px] bg-slate-200 p-2.5 ml-[3rem] form ">
      <div className="map">
        <div className="h-1 w-20  bg-secondary sm:w-32 m-auto"></div>
        <h2 className="mapHeading">Our Location</h2>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3624.2278858358354!2d46.76276798000868!3d24.7190555213527!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjTCsDQzJzA4LjYiTiA0NsKwNDYnMDMuNSJF!5e0!3m2!1sen!2sus!4v1736676033442!5m2!1sen!2sus"
          className="mapDesign"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <div data-aos="fade-right">
        <div className="flex justify-center">
          <div className="flex-col items-center w-[100%]  md:justify-center md:flex">
            <div className=" w-[100%] flex items-center justify-center ">
              <div className="h-1 w-20  bg-secondary sm:w-32"></div>
            </div>
            <h1 className="text-primary text-[25px] font-bold sm:text-[35px] text-center">
              Get In Touch
            </h1>
            <form onSubmit={handleSubmit} className="md:w-2/3 w-full  bg-white p-2 md:px-4 md:py-2 rounded-sm">

              <div className="flex-row mt-0 sm:flex md:flex-col">
                <div className="w-full mr-7 mb-6 md:mr-0">
                  <div>
                    {" "}
                    <div>
                      <label>Name</label>
                    </div>
                    <div>
                      <label className="text-[#666666] text-[12px]"></label>
                    </div>
                    <div className="relative group">
                      <input
                        name="name"
                        value={mail.name}
                        onChange={handleChange}
                        required
                        type="text"
                        className="border h-12 bg-gray-100 
          pl-5 pr-12 py-1  rounded-lg w-full focus:outline-none focus:ring-1 focus:ring-primary
         focus:bg-primary
         text-slate-900
         focus:text-white
      "
                      />
                      <div className="absolute inset-y-0 right-0 flex items-center pr-3 group-active:animate-bounce group-active:duration-1000">
                        <Icon
                          icon="icon-park-outline:edit-name"
                          color="#7e22ce"
                          width="26"
                          height="26"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-full mb-6 sm:ml-4 md:ml-0">
                  <div>
                    {" "}
                    <div>
                      <label>Email</label>
                    </div>
                    <div>
                      <label className="text-[#666666] text-[12px]"></label>
                    </div>
                    <div className="relative group">
                      <input
                        value={mail.email}
                        onChange={handleChange}
                        name="email"
                        required
                        type="text"
                        className="border h-12 bg-gray-100 
          pl-5 pr-12 py-1  rounded-lg w-full focus:outline-none focus:ring-1 focus:ring-primary
         focus:bg-primary
         text-slate-900
         focus:text-white
      "
                      />
                      <div className="absolute inset-y-0 right-0 flex items-center pr-3 group-active:animate-bounce group-active:duration-1000">
                        <Icon
                          icon="material-symbols:mark-email-read-outline"
                          color="#7e22ce"
                          width="26"
                          height="26"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex-row sm:flex md:flex-col mb-6">
                <div>
                  {" "}
                  <div>
                    <label>Phone</label>
                  </div>
                  <div>
                    <label className="text-[#666666] text-[12px]"></label>
                  </div>
                  <div className="relative group">
                    <input
                      value={mail.phone}
                      onChange={handleChange}
                      name="phone"
                      type="tel"
                      required
                      className="border h-12 bg-gray-100 
          pl-5 pr-12 py-1  rounded-lg w-full focus:outline-none focus:ring-1 focus:ring-primary
         focus:bg-primary
         text-slate-900
         focus:text-white
      "
                    />
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 group-active:animate-bounce group-active:duration-1000">
                      <Icon
                        icon="material-symbols:phone-enabled-sharp"
                        color="#7e22ce"
                        width="26"
                        height="26"
                      />
                    </div>
                  </div>
                </div>

                <div className="w-full sm:ml-4 md:ml-0 mt-6">
                  <div>
                    {" "}
                    <div>
                      <label>Country</label>
                    </div>
                    <div>
                      <label className="text-[#666666] text-[12px]"></label>
                    </div>
                    <div className="relative group">
                      <input
                        value={mail.country}
                        onChange={handleChange}
                        name="country"
                        type="text"
                        required
                        className="border h-12 bg-gray-100 
          pl-5 pr-12 py-1  rounded-lg w-full focus:outline-none focus:ring-1 focus:ring-primary
         focus:bg-primary
         text-slate-900
         focus:text-white
      "
                      />
                      <div className="absolute inset-y-0 right-0 flex items-center pr-3 group-active:animate-bounce group-active:duration-1000">
                        <Icon
                          icon="material-symbols:location-away-outline"
                          color="#7e22ce"
                          width="26"
                          height="26"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-4">
                <div>
                  <label>Comments</label>
                </div>
                <div>
                  <label className="text-[#666666] text-[12px]">
                    more details
                  </label>
                </div>
                <textarea
                  value={mail.msg}
                  onChange={handleChange}
                  name="msg"
                  required
                  className="border  bg-gray-100 
          pl-5 pr-12 py-1  rounded-lg w-full focus:outline-none focus:ring-1 focus:ring-primary
         focus:bg-slate-900
         text-slate-900
         focus:text-white"
                  rows="6"
                ></textarea>
              </div>

              <button
                type='submit'
                className="p-3 bg-[#f59e0b] w-full mt- text-white text-bold text-lg rounded-md hover:bg-secondary font-bold hover:duration-200 hover:shadow-slate-500 hover:shadow"
              >
                {isLoading ? <CircularProgress /> : 'Submit'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetTouchFrom;
